import { filterNames } from '../constants/common';
import {
  SET_SEARCH,
  SET_FILTER_VISIBLE,
  RESET_FILTER_STATE,
  SET_PERIOD,
  SET_TYPES,
  SET_COMPANIES,
  SET_STREETS,
  SET_HOUSES,
  SET_ADDRESSES,
  SET_ONLY_ACTIVE,
  SET_SELECTED_INFO,
  SET_EDITOR_LINK_MODAL_DATA,
  SET_EDITOR_PHONE_MODAL_DATA,
  SET_EDITOR_STATE,
} from './actionsTypes';

export const setSearch = (search) => ({
  type: SET_SEARCH,
  payload: search?.trim() || '',
});

export const setFilterVisible = (visible) => ({
  type: SET_FILTER_VISIBLE,
  payload: visible,
});

const filterTypes = {
  [filterNames.period]: SET_PERIOD,
  [filterNames.types]: SET_TYPES,
  [filterNames.companies]: SET_COMPANIES,
  [filterNames.streets]: SET_STREETS,
  [filterNames.houses]: SET_HOUSES,
  [filterNames.addresses]: SET_ADDRESSES,
  [filterNames.onlyActive]: SET_ONLY_ACTIVE,
};

export const setFilterState = ({ filterName, value }) => ({
  type: filterTypes[filterName],
  payload: value,
});

export const resetFilterState = () => ({ type: RESET_FILTER_STATE });

export const setSelectedInfo = (info) => ({
  type: SET_SELECTED_INFO,
  payload: info,
});

export const setEditorState = (state) => ({
  type: SET_EDITOR_STATE,
  payload: state,
});

export const setEditorLinkModalData = (data) => ({
  type: SET_EDITOR_LINK_MODAL_DATA,
  payload: data,
});

export const setEditorPhoneModalData = (data) => ({
  type: SET_EDITOR_PHONE_MODAL_DATA,
  payload: data,
})
